import React, { useCallback } from 'react';
import { NavLink, type NavLinkProps } from 'react-router';

export type NavLinkWrapperProps = NavLinkProps & {
  activeIndicatorEnabled?: boolean;
  overrideIsActive?: boolean;
};

/**
 * @deprecated - Please use the {@link SideNavLink} instead.
 */
export const NavLinkWrapper = React.forwardRef<HTMLAnchorElement, NavLinkWrapperProps>(
  ({ overrideIsActive, activeIndicatorEnabled, className, children, ...rest }, ref) => {
    const getActiveClassName = useCallback(
      (isActive: boolean) => {
        if (!activeIndicatorEnabled) {
          return '';
        }

        const checkFlag = overrideIsActive !== undefined ? overrideIsActive : isActive;
        return `${checkFlag ? 'active' : ''}`;
      },
      [activeIndicatorEnabled, overrideIsActive]
    );

    return (
      <NavLink ref={ref} className={({ isActive }) => `${className} ${getActiveClassName(isActive)}`} {...rest}>
        {children}
      </NavLink>
    );
  }
);
